import { Extension } from '@tiptap/core';

export const ResetFormattingOnEnter = Extension.create({
  name: 'resetFormattingOnEnter',
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor: editorInstance }) => {
        if (
          editorInstance.isActive('bold') ||
          editorInstance.isActive('italic')
        ) {
          // First create a new paragraph
          editorInstance.commands.splitBlock();

          // Then remove the formatting from the new paragraph
          editorInstance.commands.unsetBold();
          editorInstance.commands.unsetItalic();

          return true;
        }

        return false;
      },
    };
  },
});
